import { combineReducers } from "redux";
import { optionReducer } from "./actions";

const rootReducer = combineReducers({
    option: optionReducer,
});

export default rootReducer;